<!--Liste d'item utilisé à gauche des page pour la sélection des items principale-->=
<template>
    <div id="s-itemList" style="z-index: 650">
<!--VERSION DESKTOP - SIMPLE COLONNE ***************************************************************************************************************************-->
    <div class="d-none d-md-block">
        <div class="itemListBack" :style="'position: fixed; width: ' + myWidth + '%;padding-top: ' + padTop + 'px;'">
            <div v-show="!hide"> <!--Pour cacher l'ensemble de la liste : UTILE POUR MODE PORTABLE-->
                <!--<b-row>
                    <h6 class="showId">
                            ID : {{selectedItems.id}}<br>
                            Qte : {{content.length}}<br>
                    </h6>
                </b-row>-->

            <div class="itemListTop" :style="'max-width: ' + searchZoneWidth + 'px'"> <!--Permet de conserver la taille de la zone de recherche meme en fullScreen-->
            
                <div style="display: flex;">
                    <!--3 DOTS-->
                    <s-button
                        name="btnOpenMenu"
                        id="btnOpenMenu" 
                        @action="openMenu=!openMenu"
                        iconName="threeDotsVertical"
                        :size="getAllSize.buttonItemList">
                    </s-button>
                    
                    <!--BOUTON POUR METTRE EN PLEIN ÉCRAN-->
                    <s-button 
                        name="btnFullScreen"
                        id="btnFullScreen" 
                        @action="fullScreen = !fullScreen"
                        :iconConditionVar="fullScreen"
                        iconName1="arrow-bar-left"
                        iconName2="arrow-bar-right"
                        color="gray"
                        :size="getAllSize.buttonItemList"
                        style="margin-left: 5px">
                    </s-button>
                    <!--DROP DOWN-->
                    <b-dropdown id="dropdown-divider" offset="25" :text="perPage.toString()" :size="getAllSize.buttonItemList" class="btnItemPerPage" style="margin-left: 5px; height: 26px">
                        <b-dropdown-item-button @click="changePerPage(5)">5</b-dropdown-item-button>
                        <b-dropdown-item-button @click="changePerPage(10)">10</b-dropdown-item-button>
                        <b-dropdown-item-button @click="changePerPage(20)">20</b-dropdown-item-button>
                        <b-dropdown-item-button @click="changePerPage(50)">50</b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button @click="changePerPage(-1)">Tous</b-dropdown-item-button>
                    </b-dropdown>

                    <!--CHAMPS RECHERCHE-->
                    <b-input-group class="mb-2" :size="getAllSize.buttonItemList">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                            <b-form-input class="searchInput" autocomplete="off" id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="txtRecherche">
                        </b-form-input>
                        
                        <!--BOUTON CLEAR-->
                        <b-input-group-append is-text class="cursorPoint" @click="txtRecherche = ''">
                            <b-icon icon="x"></b-icon>
                        </b-input-group-append>
                    </b-input-group>
                    <!--FIN - CHAMPS RECHERCHE-->
                </div>    
                <!--PAGINATION-->
                <!--<b-pagination style="margin-top: 10px;" pills v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" :limit="pageLimit"></b-pagination>-->
                <div>
                    <pagination
                        class="paginationDiv"
                        :total="totalRows"
                        :totalPages="totalRows / perPage"
                        :perPage="perPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                        :maxVisibleButtons="pageLimit">
                    </pagination>
                </div>
            </div>

                <!--AFFICHAGE DE LA LISTE D'ITEM ================================================================================================================================================================================================================== -->

                <!--VERSION SIMPLE COLONNE **************************************************************************************************************************************************************************************************************************** -->
                <!--{{getScreenSize}}-->
                <div v-show="!multiColonne" class="mainItemListContainer scrollItems borderMain" :style="'max-height: ' + itemHeight+ 'px'">
                    <b-list-group style="margin-top: 5px">
                        <b-list-group-item 
                            :class="item.id == selectedItems.id ? 'cursorPoint btnStylSelected ' + cssFirstLetter: 'cursorPoint btnStyle ' + cssFirstLetter" 
                            v-for="(item) in lists" 
                            :key="item.index" 
                            @click="handleInput(item)">
                            
                            <template v-if="showField2==null"><!--Si aucun 2e champs à afficher-->
                                <span v-if="showFieldAux==null || showFieldAux=='' || item[showFieldAux]==''">{{item[showField]}}</span>
                                <span v-else>{{item[showField] + ' (' + item[showFieldAux] + ')'}}</span>
                            </template>
                            <template v-else><!--Si 2e champs a afficher-->
                                <span v-if="showFieldAux==null || showFieldAux=='' || item[showFieldAux]==''">{{item[showField] + ' ' + item[showField2]}}</span>
                                <span v-else>{{item[showField] + ' ' + item[showField2] + ' (' + item[showFieldAux] + ')'}}</span>
                            </template>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <!--FIN - VERSION SIMPLE COLONNE **************************************************************************************************************************************************************************************************************************** -->
                <!--VERSION TABLEAU - MULTI-COLONNE **************************************************************************************************************************************************************************************************************************** -->
                <div v-show="multiColonne" class="borderMain" :style="'max-height: ' + itemHeight + 'px'">
                    
                    <!--SELECTION DES COLONNES - MENU NON VISIBLE SANS LE CLIQUE SUR LE BOUTON MENU-->
                    <div class="colomnSelectionMenu" v-show="openMenu">
                        <b-form-checkbox v-for="(field) in fields" :key="field.index" switch :size="chkSize" v-model="field.show">
                            <template v-if="field.label">{{(field.label)}}</template>
                            <template v-else>{{field.colName}}</template>
                        </b-form-checkbox>
                        <br>
                        <!--<b-button :variant="getTheme.warning" style="width: 50%;" @click="openMenu=!openMenu">{{$t("g_Ok")}}</b-button>-->
                        <s-button style="width: 50%;" text="g_Ok" @click.native="openMenu=!openMenu"></s-button>
                    </div>
                    <!--FIN - SELECTION DES COLONNES-->
                    <div class="table-wrapper" :style="'max-height: ' + itemHeight+ 'px;min-height: ' + itemHeight+ 'px'">
                    <table style="width: 100%; z-index: 998;">
                        <thead class="fontSourceCodePro-Bold hStyle cursorPoint">
                            <tr>
                                <!--<th style="width: 15px" @click="openMenu=!openMenu"><b-icon icon="threeDotsVertical" font-scale="1"></b-icon></th>-->
                                <th :style="field.width ? 'width: ' + field.width + 'px;' : ''" v-for="(field) in fields" :key="field.index" v-show="field.show" @click="sort(field.colName)" >
                                    <!--Affichage du titre des colonne-->
                                    <template v-if="field.label">
                                        {{field.label}}
                                    </template>
                                    <template v-else>
                                        {{field.colName}}
                                    </template>
                                    <!--FIN - Affichage du titre des colonne-->
                                     
                                    <b-icon class="upDownArrow" v-show="sortBy==field.colName" :icon="sortDirection=='asc' ? 'chevron-down':'chevron-up'" :variant="getTheme.dark" font-scale="0.8"></b-icon>
                                    <!--<b-icon v-show="sortBy==field.colName" :icon="sortDirection=='asc' ? 'arrow-down':'arrow-up'" :variant="getTheme.dark" font-scale="0.8"></b-icon>-->
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :class="item.id == selectedItems.id ? 'fontSourceCodePro-Bold fontSize12 cursorPoint selectedowStyle' : 'fontSourceCodePro-Bold fontSize12 cursorPoint allrowStyle'" v-for="(item) in lists" :key="item.index">
                                <!--<td :style="field.alignH ? 'text-align: ' + field.alignH + ';' : ''" v-for="(field) in fields" :key="field.index">{{item[field.colName]}}</td>-->
                                <!--:style="'text-align: ' + field.alignH + ';'" -->
                                    <!--<td class="leftColBack"></td>-->
                                    <td :contenteditable="field.edit" :class="field.color == true ? 'rowStyle rowStyleColor2' : 'rowStyle'"
                                        @click="handleInput(item)"
                                        v-for="(field) in fields" 
                                        :style="'text-align: ' + field.alignH + ';'"
                                        :key="field.index"
                                        v-show="field.show"
                                    >
                                        {{item[field.colName]}}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <!--FIN - VERSION TABLEAU - MULTI-COLONNE **************************************************************************************************************************************************************************************************************************** -->
            </div>
        </div>
    </div>
<!--FIN - VERSION DESKTOP***************************************************************************************************************************-->
<!--VERSION PORTABLE ***************************************************************************************************************************-->
    <!--BOUTON FLOTTANT POUR RECHERCHE ITEM-->
    <div @click="$bvModal.show('itemList'), portable=true" class="d-xs-none d-sm-none">
        <fab
            style="margin-top: 90px"
            :icon-size="fabScale"
            position="top-right"
            bg-color="#006aff"
            ripple-color="#0b223a"
            main-icon="search"
            z-index="400"
        ></fab>
    </div>
    <!--BOUTON FLOTTANT POUR RETOUR EN HAUT DE PAGE-->
    <div @click="backToTop()" class="d-xs-none d-sm-none">
        <fab
            style="margin-top: 90px;"
            icon-size="small"
            position="bottom-right"
            bg-color="#0b223a"
            ripple-color="#0b223a"
            main-icon="north"
            z-index="450"
        ></fab>
    </div>
    <!--FENETRE DE RECHERCHE-->
    <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" id="itemList" title="Recherche" hide-footer>
        <!--LIGNE DE RECHERCHE ITEM-->
        <b-row class="addLicContainer">
            <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                    <b-form-input id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="txtRecherche"></b-form-input>
                <b-input-group-append is-text class="cursorPoint" @click="txtRecherche = ''">
                    <b-icon icon="x"></b-icon>
                </b-input-group-append>
            </b-input-group>
        </b-row>
        <!--LIGNE ACTIF / INACTIF-->
        <b-row>
            <s-duoSelector :text1="$t('cmp_Actif')" :text2="$t('cmp_Inactif')" invertTrueFalse :value="active" :returnValue.sync="active"></s-duoSelector>
        </b-row>
        <!--LISTE DES ITEMS A RECHERCHER-->
        <div class="scrollItems borderMain" :style="'max-height: ' + itemHeight+ 'px'">
            <b-list-group style="margin-top: 5px">
                <b-list-group-item :class="item.id == selectedItems.id ? 'cursorPoint btnStylSelected ' + cssFirstLetter: 'cursorPoint btnStyle ' + cssFirstLetter" v-for="(item) in lists" :key="item.index" @click="handleInput(item), txtRecherche = ''">
                    <template v-if="showField2==null"><!--Si aucun 2e champs à afficher-->
                        <span v-if="showFieldAux==null || showFieldAux=='' || item[showFieldAux]==''">{{item[showField]}}</span>
                        <span v-else>{{item[showField] + ' (' + item[showFieldAux] + ')'}}</span>
                    </template>
                    <template v-else><!--Si 2e champs a afficher-->
                        <span v-if="showFieldAux==null || showFieldAux=='' || item[showFieldAux]==''">{{item[showField] + ' ' + item[showField2]}}</span>
                        <span v-else>{{item[showField] + ' ' + item[showField2] + ' (' + item[showFieldAux] + ')'}}</span>
                    </template>
                </b-list-group-item>
            </b-list-group>
        </div>

    </b-modal>

  <!-- FIN - VERSION PORTABLE ***************************************************************************************************************************-->

    </div>
   
</template>

<script>
import {mapGetters} from 'vuex'
//import axios from 'axios';
import fab from 'vue-fab'
import pagination from '../../pagination.vue'

export default{
    name: 's-itemList',
    components: {
        fab,
        pagination
    },
    props: {
        content: null, //Contenu de la liste
        showField: String, //Champs à afficher
        showField2: String, //Champs secondaire à afficher
        showFieldAux: String, //Champs auxiliare qui apparaitra entre parenthese apres le champs principal
        returnField: String, //Le champs à retourner
        activeField: String, //Le champs qui défini si l'item est actif
        selectedItems: null, //Item sélectionné
        subContent: String, //Sous section de l'objet principal
        apiAddSub: String, //Adresse pour aller lire le sub content
        getSubCol: String, //Colonne a utiliser pour la recherche des sous-objet
        methodsReturn: String, //Nom de la methode a executer dans le parent
        subMethodsReturn: String, //Nom de la 2e methode a executer dans le parent
        //subMethodsReturnValue: String, //Nom de la 2e methode a executer dans le parent - valeur à retourner
        firstLetterNotUpper: Boolean, //Si la premiere lettre est en majustcule
        //si on affiche multi-colonne alors on doit valider avec un true
        multiColonne: Boolean,
        fields: null,
        /*
        colName :       Nom du champs à afficher
        width :      Largeur forcé de la colonne (0 ou null = largeur automatique)
        label :      Variable du label a afficher
        alignH :     Alignement horizontal du texte : left, right, center
        .alignV :    Alignement vertical du texte
        show :       Si visible
        edit :       Si on peut modifier le contenu
        color :      Si a true alors la colonne prend la 2e couleur disponible
        */

       //---sortBy :     Tri au chargement : devra être un paramatre global du component
    },
    data() {
        return {
            size:'sm',
            chkSize: this.$store.getters.getCheckSize,
            currentPage: 1,
            perPage: -1,
            txtRecherche: '',
            active: true,
            subFromApi: null,
            hide: false,
            fullScreen: false,
            sortBy: 'Nom1',
            sortDirection: 'asc',
            portable: false,
            isBold: false,
            openMenu: false,
            msg: ''
            //multiColonne: false
        }
    },

    methods: {
    onPageChange(page) {
      console.log(page)
      this.currentPage = page;
    },
        myGeeks(x) {
            console.log("Row index is: " + x.rowIndex);
        },
        ttt(x){
            console.log(x)
        },
        handleInput(valeur) {
            this.$bvModal.hide('itemList')

            /*
            if (this.methodsReturn) //Si on execute une methode dans le parent
            {
                this.$emit('update:returnValue', this.$CObj(valeur))
                this.$emit(this.methodsReturn, valeur.id) 
                         
            }
            else //Chargement direct des sous-objet
            {
                if (this.subContent == '' || this.subContent == null)
                {
                    this.$emit('update:returnValue', this.$CObj(valeur))
                }
                else
                {
                    axios.get(this.apiAddSub + '?licence=' + this.$store.getters.getworkLicence + '&' + this.getSubCol + '=' + valeur.codeTax + '&magNumber=1', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                        .then(response => {
                            this.$emit('update:returnSubValue', this.$CObj(response.data))
                            this.$emit('update:returnValue', this.$CObj(valeur))
                        })
                        .catch(e => {
                        this.errors.push(e)
                        })
                }
            }
            //if (this.subMethodsReturn) //Si on execute une methode dans le parent
            //{
                  this.$emit('subMethodsReturn')        
            //}
            */
            this.$emit('update:returnValue', this.$CObj(valeur))
            this.$emit('getRowdDetail', valeur.id) 
        },
        sort: function(s){
            console.log(s)
                if(s === this.sortBy) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }
                this.sortBy = s;
            },
        backToTop(){
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        getSelectItem(itemNumber){
            itemNumber
        },
        changePerPage(qte){
            if(qte == -1)
            {
                this.currentPage = 1;
                this.perPage = this.recherche.length;
            }
            else
            {
                this.currentPage = 1;
                this.perPage = qte;
            }
        },
      cache(){
          console.log('Cache Cleared');
      },
      test(){
          console.log('test action');
      },
      alert(){
          alert('Clicked on alert icon');
      },
      checkItemHeight(){
                    if(this.getScreenSize.width < 1200)
            {
                if (this.multiColonne && this.portable == false)
                    {return this.getScreenSize.height - 360}
                else
                    {return this.getScreenSize.height - 250}
            }
            else
            {
                if (this.multiColonne && this.portable == false)
                    {return this.getScreenSize.height - 200} //multi colonne : full screen
                else
                    {return this.getScreenSize.height - 200} //simple colonne
            }
      }
    },
    computed: {
        ...mapGetters(['getTheme', 'getScreenSize', 'getCheckSize', 'getAllSize']),
        status() {
            return this.value
        },
        searchZoneWidth(){
            //return (this.getScreenSize.width * this.myWidth) / 100;
            if(this.getScreenSize.width < 1200)
                {
                    return ((this.getScreenSize.width * 50) / 100) - 20
                }
                else
                {
                    return ((this.getScreenSize.width * 33) / 100) -20
                }

        },
        myWidth(){
            if(this.fullScreen == false)
            {
                if(this.getScreenSize.width < 1200)
                {
                    return 33 //50
                }
                else
                {
                return 33
                }
            }
            else
            {
                return 100
            }
        },
        itemHeight(){
            return this.checkItemHeight()
        },
        fabScale(){
            if(this.getScreenSize.width < 430)
                {
                    return 'small'
                }
                else
                {
                return 'large'
                }
        },
        recherche() {
            const search = this.txtRecherche.toLowerCase().trim();

            if (this.multiColonne && this.portable == false)
            {

                var items = this.sortedProducts.filter(c => c[this.activeField] == this.active); //Filtrer les items actif ou inactif
                if (!search) return items;

                var filteredItems = [];
                items.forEach(function(item){
                    var keys = Object.keys(item)
                    keys.forEach(function(key){
                        if(item[key].toString().toLowerCase().indexOf(search) > -1)
                        {
                            filteredItems.push(item)
                        }
                    })
                });

                return [...new Set(filteredItems)]  //filteredItems;
            }
            else
            {
                if (this.content != null)
                {
                
                if (!search) return this.content.filter(c => c[this.activeField] == this.active);

                if (this.showField2 == null)
                {
                    return this.content.filter(c => c[this.showField].toLowerCase().indexOf(search) > -1 && c[this.activeField] == this.active);
                }
                else
                {
                    return this.content.filter(c => c[this.showField2].toLowerCase().indexOf(search) > -1 || c[this.showField].toLowerCase().indexOf(search) > -1 && c[this.activeField] == this.active);
                }
                //return search
                }
                else
                {
                    return this.content
                }
            }
        },
        recherche2() {
            if (this.sortedProducts != null)
            {
            const search = this.txtRecherche.toLowerCase().trim();
            if (!search) return this.sortedProducts.filter(c => c[this.activeField] == this.active);

            if (this.showField2 == null)
            {
                return this.sortedProducts.filter(c => c[this.showField].toLowerCase().indexOf(search) > -1 && c[this.activeField] == this.active);
            }
            else
            {
                return this.sortedProducts.filter(c => c[this.showField2].toLowerCase().indexOf(search) > -1 || c[this.showField].toLowerCase().indexOf(search) > -1 && c[this.activeField] == this.active);
            }
            //return search
            }
            else
            {
                return this.sortedProducts
            }

        },
        lists () {
          const items = this.recherche
          // Return just page of items needed
          return items.slice(
            (this.currentPage - 1) * this.perPage,
            this.currentPage * this.perPage
          )
        },
        sortedProducts: function(){
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return this.content.sort((p1,p2) => {
                let modifier = 1;
                if(this.sortDirection === 'desc') modifier = -1;
                if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
                if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                return 0;
            });
        },
        totalRows () {
          return this.recherche.length
        },
        cssFirstLetter() {
            if (this.firstLetterNotUpper)
                {return ''}
            else
                {return 'btnFirstLetter'}
            
        },
        pageLimit(){
            if (this.getScreenSize.width >= 2100)
            {return 11}
            else if (this.getScreenSize.width < 2100 && this.getScreenSize.width >= 1800 )
            {return 8}
            else if (this.getScreenSize.width < 1800 && this.getScreenSize.width >= 1200 )
            {return 5}
            else if (this.getScreenSize.width < 1200 && this.getScreenSize.width >= 1000 )
            {return 7}
            else if (this.getScreenSize.width < 1000 && this.getScreenSize.width >= 700 )
            {return 5}
            else
            {return 5}
        },
        padTop() {
            if(this.getAllSize == 'sm')
            {return 8;}
            else if(this.getAllSize == 'md')
            {return 13;}
            else if(this.getAllSize == 'lg')
            {return 21;}
            else
            {return 0}
        }
    },
    mounted() {
        this.checkItemHeight()
        this.changePerPage(-1)
    }, 
    watch: {
        content : function() {
            this.changePerPage(-1)
        }
    }   
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/components/itemListCss.scss";
@import "../../../assets/css/components/itemListTableMenu.scss";
</style>